export default {
  upper: (str) => str.toUpperCase(),
}
